import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStreak = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 246,
	height: 186,
	viewBox: "0 0 246 186",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "streak-clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_17004",
			"data-name": "Rectangle 17004",
			width: 246,
			height: 186,
			transform: "translate(383 590)",
			fill: "#fff",
			stroke: "#707070",
			strokeWidth: 1
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "streak-clip-path-2",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_17003",
			"data-name": "Rectangle 17003",
			width: 78.084,
			height: 152.015,
			fill: "none"
		})
	})] }), /* @__PURE__ */ _jsx("g", {
		id: "Mask_Group_14467",
		"data-name": "Mask Group 14467",
		transform: "translate(-383 -590)",
		clipPath: "url(#streak-clip-path)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_14588",
			"data-name": "Group 14588",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_39767",
				"data-name": "Path 39767",
				d: "M95.729.04c30.49.814,61.381,14.079,69.428,45.039,3.957,15.225-1.238,31.376,3.717,46.4,5.011,15.191,20.908,19.631,31.8,29.8,13.151,12.275,17.079,33.558,8.306,49.316-9.469,17.006-32.359,25.5-50.968,18.914-16.059-5.684-26.929-20.186-41.15-29.44A70.482,70.482,0,0,0,74.8,148.918c-8.52.483-16.961,2.518-25.485,2.1C25.726,149.859,6.486,129.2,1.6,106.582S3.624,60.328,14.35,39.732c4.12-7.911,8.925-15.683,15.793-21.485C40.183,9.763,53.549,6.325,66.408,3.138A110.847,110.847,0,0,1,95.729.04Z",
				transform: "matrix(0.643, -0.766, 0.766, 0.643, 355.885, 697.188)",
				fill: "#7b8efa",
				opacity: .137
			}), /* @__PURE__ */ _jsx("g", {
				id: "Group_14587",
				"data-name": "Group 14587",
				transform: "translate(461.998 598.985)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group_14586",
					"data-name": "Group 14586",
					clipPath: "url(#streak-clip-path-2)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Path_39768",
							"data-name": "Path 39768",
							d: "M74.8,184.819c0,2.714-15.663,4.914-34.984,4.914s-34.984-2.2-34.984-4.914S20.5,179.9,39.82,179.9s34.984,2.2,34.984,4.914",
							transform: "translate(-1.014 -37.719)",
							fill: "#7284fa"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_39769",
							"data-name": "Path 39769",
							d: "M69.605,96.483c-12.7-19.427,5.148-39.6,5.148-39.6-22.1,0-35.712,17.525-37.9,34.028C28.621,76.725,24.157,72.44,6.9,70.895c0,0,16.973,12.226,2.939,30.71C3.084,110.5-.221,119.079.023,126.6c-.008.272-.023.542-.023.816,0,17.459,18.306,31.614,39.912,31.614,37.557,0,47.285-35.626,29.693-62.543",
							transform: "translate(0 -11.925)",
							fill: "#fd9fbc"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_39770",
							"data-name": "Path 39770",
							d: "M36.712,0S13.528,14.226,24.593,30.56,39.346,50.735,36.712,61.723c0,0,11.855-7.98,6.455-25.368S31.969,9.484,36.712,0",
							transform: "translate(-4.529)",
							fill: "#fd9fbc"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_39771",
							"data-name": "Path 39771",
							d: "M61.2,28.878s4.215,14.226,0,22.13c0,0,14.226-11.065,0-22.13",
							transform: "translate(-12.831 -6.055)",
							fill: "#fd9fbc"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_39772",
							"data-name": "Path 39772",
							d: "M25.685,112.951s-20.286,17.124-2.9,34.512,42.942,7.744,45.577-7.113c4.206-23.721-16.07-36.62-12.645-46.894,0,0-20.812,20.023-17.651,34.512a22.58,22.58,0,0,1-12.382-15.016",
							transform: "translate(-3.301 -19.594)",
							fill: "#fed092"
						})
					]
				})
			})]
		})
	})]
});
export default SvgStreak;
